import { GridColumnMenuFilterUIProps, GridColumnMenuProps } from "@progress/kendo-react-grid";
import { ColumnMenuWithFilterUi } from "../../../../../Layout/Grid/Filter/ColumnMenuWithFilterUi";
import { CustomFilterUiRadioButton } from "../../../../../Layout/Grid/Filter/CustomFilterUiRadioButton";

export function IsUnloadedInMultiDockColumnMenu(props: GridColumnMenuProps) {
  const filterUI = (filterUIProps: GridColumnMenuFilterUIProps) => (
    <CustomFilterUiRadioButton
      {...filterUIProps}
      values={[
        {
          label: "Unloaded",
          value: true,
        },
        {
          label: "Loaded",
          value: false,
        },
      ]}
    />
  );

  return <ColumnMenuWithFilterUi {...props} filterUI={filterUI} />;
}
